@use '../../styling/colors.scss' as *;
@use '../../styling/form-controls.scss' as *;

.InputPair {
  display: grid;
  grid-template-columns: 1fr 1fr;
  width: 100%;

  > * {
    border: 1px solid $form-control-color;
    min-width: auto;
    flex-basis: auto;
    flex-grow: 1;

    &:first-child {
      border-right: none;
      border-radius: 4px 0 0 4px;
    }

    &:last-child {
      border-left: none;
      border-radius: 0 4px 4px 0;
    }

    &:hover,
    &:active,
    &:focus {
      outline: 0;
    }
  }
}
